import Dashboard from '@/features/cleaner/dashboard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/dashboard'
)({
  component: Dashboard,
});
